import { parseInTz } from 'helpers/date';
import { constructURL } from 'helpers/url';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['patientAutocomplete', 'dateOfService'];

  #abortController = new AbortController();

  connect() {
    const serviceRateContainer = document.getElementById('service-container');
    const autocompleteServiceRates = serviceRateContainer.querySelector('awc-autocomplete');
    const billToContainer = document.getElementById('bill-container');
    const autocompleteFacilities = billToContainer.querySelector('awc-autocomplete');
    const serviceRatesUrl = $('#service-rates-url').val();
    const facilitiesUrl = $('#facilities-url').val();
    const patientsUrl = $('#patients-url').val();

    // Initial state - check if facility is already selected (prefilled)
    if (!autocompleteFacilities.value) {
      this.disableServiceDropdown(autocompleteServiceRates);
    } else {
      // Facility is prefilled, so enable service dropdown and set correct URL
      this.enableServiceDropdown(autocompleteServiceRates);
      autocompleteServiceRates.setAttribute('src', `${serviceRatesUrl}?facility_id=${autocompleteFacilities.value}`);

      // Update patient list based on prefilled facility
      this.updatePatientList(`${patientsUrl}?facility_id=${autocompleteFacilities.value}&by_assigned_facility=true`);
    }

    // When a facility is selected
    $(autocompleteFacilities).on('awc-autocomplete:commit', () => {
      // Enable service dropdown and update its source URL
      this.enableServiceDropdown(autocompleteServiceRates);
      autocompleteServiceRates.setAttribute('src', `${serviceRatesUrl}?facility_id=${autocompleteFacilities.value}`);

      // Update patient list based on selected facility
      this.updatePatientList(`${patientsUrl}?facility_id=${autocompleteFacilities.value}&by_assigned_facility=true`);
    });

    // When facility selection is cleared
    $(autocompleteFacilities).on('awc-autocomplete:clear', () => {
      // Disable service dropdown and reset its source URL
      this.disableServiceDropdown(autocompleteServiceRates);
      autocompleteServiceRates.setAttribute('src', serviceRatesUrl);

      // Clear any selected service
      autocompleteServiceRates.clear();

      // Update patient list
      this.updatePatientList(`${patientsUrl}?by_assigned_facility=true`);
    });

    // When service selection is cleared
    $(autocompleteServiceRates).on('awc-autocomplete:clear', () => {
      // Reset facility dropdown source URL
      autocompleteFacilities.setAttribute('src', facilitiesUrl);
    });

    // When "Add patient" button is clicked
    $('#patient-button').on('click', () => {
      setTimeout(() => {
        if (autocompleteFacilities.value) {
          this.updatePatientList(
            `${patientsUrl}?facility_id=${autocompleteFacilities.value}&by_assigned_facility=true`
          );
        } else {
          this.updatePatientList(`${patientsUrl}?by_assigned_facility=true`);
        }
        this.propagateDateOfService();
      }, 500);
    });

    // When the parent date_of_service changes, push it into every visit-note autocomplete
    if (this.hasDateOfServiceTarget) {
      this.dateOfServiceTarget.addEventListener('change', () => this.propagateDateOfService(), { signal: this.#abortController.signal });
    }
  }

  disconnect() {
    this.#abortController.abort();
  }

  // Properly disable the Ambiki autocomplete element
  disableServiceDropdown(autocompleteElement) {
    // According to Ambiki documentation, set the disabled attribute
    autocompleteElement.disabled = true;

    // Also set the attribute for browsers that might need it
    autocompleteElement.setAttribute('disabled', '');

    // Add a visual indicator class to the container
    const serviceContainer = document.getElementById('service-container');
    if (serviceContainer) {
      serviceContainer.classList.add('field-disabled');

      // Add helper text if it doesn't exist
      if (!serviceContainer.querySelector('.helper-text')) {
        const helperText = document.createElement('small');
        helperText.className = 'helper-text text-muted';
        helperText.innerHTML = 'Please select a facility first';
        serviceContainer.appendChild(helperText);
      }
    }
  }

  // Properly enable the Ambiki autocomplete element
  enableServiceDropdown(autocompleteElement) {
    // According to Ambiki documentation, remove the disabled state
    autocompleteElement.disabled = false;

    // Also remove the attribute for browsers that might need it
    autocompleteElement.removeAttribute('disabled');

    // Remove the visual indicator class from the container
    const serviceContainer = document.getElementById('service-container');
    if (serviceContainer) {
      serviceContainer.classList.remove('field-disabled');

      // Remove helper text if it exists
      const helperText = serviceContainer.querySelector('.helper-text');
      if (helperText) {
        helperText.remove();
      }
    }
  }

  updatePatientList(url) {
    this.patientAutocompleteTargets.forEach((autocomplete) => {
      autocomplete.setAttribute('src', url);
    });
  }

  propagateDateOfService() {
    if (!this.hasDateOfServiceTarget || !this.dateOfServiceTarget.value) return;
    const dateOfService = parseInTz(this.dateOfServiceTarget.value).format();
    this.element
      .querySelectorAll('[data-date-of-service-records-reload-target="recordsAjaxSelect"]')
      .forEach((target) => {
        const url = constructURL(target.getAttribute('src'), { date_of_service: dateOfService });
        target.setAttribute('src', url.toString());
      });
  }
}
